<template>
    <client-page>
        <v-container>
            <div class="tit-wrap text-center">
                <h2 class="tit tit--lg">해외미술품 구매대행</h2>
            </div>

            <div class="page-section-wrap">
                <section class="page-section">
                    <div>
                        <v-row>
                            <v-col cols="12" lg="6">
                                <h2 class="tit">해외미술품 구입의 애로점</h2>
                            </v-col>
                            <v-col cols="12" lg="6">
                                <div class="page-text primary--text">
                                    <p>해외미술품 구입은 소장처 조사, 인보이스, 매매계약, 송금, 운송 등 많은 절차와 수고로움이 필요합니다.</p>
                                    <p>또한, 일정의 준수, 구입비용의 정산, 작품상태의 유지 등 여러 측면에서 거래의 안전성이 <br class="d-none d-md-block"/>매우 요구됩니다.</p>
                                    <p>개인 혹은 기업에서 여러 번 반복하여 미술품을 수입하는 경우, 세무당국의 오해를 <br class="d-none d-md-block"/>받을 수 있습니다.</p>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </section>
                <v-divider class="grey-cb"></v-divider>

                <section class="page-section">
                    <div class="mb-20 mb-md-40">
                        <h2 class="tit">구매대행 프로세스</h2>
                    </div>
                    <div>
                        <v-img src="/images/sub/service/service-museum-img.png"></v-img>
                    </div>
                </section>

                <section class="page-section">
                    <div class="mb-20 mb-md-40">
                        <h2 class="tit">캐터 옥션의 강점</h2>
                    </div>
                    <div class="my-n14 my-md-n20">
                        <v-row>
                            <v-col cols="12" sm="6">
                                <div class="h-100 py-4 py-md-6">
                                    <div class="gallery-card d-flex flex-column h-100">
                                        <div class="gallery-card__img-wrap">
                                            <v-img :aspect-ratio="585 / 240" src="/images/sub/service/service-museum-img2.png" class="grey-ef" />
                                        </div>
                                        <div class="gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30">
                                            <div class="mb-10">
                                                <h4 class="tit tit--xs d-flex flex-wrap align-center">풍부한 노하우</h4>
                                            </div>
                                            <div>
                                                <ul class="letter-list">
                                                    <li><em>-</em><span>캐터옥션은 해외 미술품을 수입, 구매해 온 최고의 노하우를 보유하고 있습니다.</span></li>
                                                    <li><em>-</em><span>캐터옥션을 통하여, 고객의 시간과 노력, 비용을 절감할 수 있습니다.</span></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <v-divider class="primary"></v-divider>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <div class="h-100 py-4 py-md-6">
                                    <div class="gallery-card d-flex flex-column h-100">
                                        <div class="gallery-card__img-wrap">
                                            <v-img :aspect-ratio="585 / 240" src="/images/sub/service/service-museum-img3.png" class="grey-ef" />
                                        </div>
                                        <div class="gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30">
                                            <div class="mb-10">
                                                <h4 class="tit tit--xs d-flex flex-wrap align-center">거래의 안전성 및 보안성 유지</h4>
                                            </div>
                                            <div>
                                                <ul class="letter-list">
                                                    <li><em>-</em><span>작품은 최상의 상태로, 고객에게 안전하게 전달됩니다.</span></li>
                                                    <li><em>-</em><span>당사는 해외 소재의 보험업체, 포장업체, 운송업체 등과의 광범위한 네트워킹을 통하여, 각종 변수와 리스크를 최소화시키면서, 해외 비지니스를 최대한 안전하게 진행합니다.</span></li>
                                                    <li><em>-</em><span>해외 수입에 따른, 수많은 단계와 절차 속에서, 고객의 익명성(anonymity), 보안성을 유지합니다. </span></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <v-divider class="primary"></v-divider>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <div class="h-100 py-4 py-md-6">
                                    <div class="gallery-card d-flex flex-column h-100">
                                        <div class="gallery-card__img-wrap">
                                            <v-img :aspect-ratio="585 / 240" src="/images/sub/service/service-museum-img4.png" class="grey-ef" />
                                        </div>
                                        <div class="gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30">
                                            <div class="mb-10">
                                                <h4 class="tit tit--xs d-flex flex-wrap align-center">높은 가격 경쟁력 및 신속한 구매 처리</h4>
                                            </div>
                                            <div>
                                                <ul class="letter-list">
                                                    <li><em>-</em><span>가격 조사 및 네고(Negotiation), 복수견적 등을 통하여 작품 원가를 절감합니다.</span></li>
                                                    <li><em>-</em><span>각 단계마다 발생하는 물류비를 절감하여 드립니다.</span></li>
                                                    <li><em>-</em><span>작품원가 및 물류비 절감을 통하여, 국내보다는 저렴한 가격으로 구입할 수 있습니다.</span></li>
                                                    <li><em>-</em><span>숙달된 노하우, 해외의 광범위한 네트워킹을 통하여 작품구입을 신속하게 진행합니다.</span></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <v-divider class="primary"></v-divider>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <div class="h-100 py-4 py-md-6">
                                    <div class="gallery-card d-flex flex-column h-100">
                                        <div class="gallery-card__img-wrap">
                                            <v-img :aspect-ratio="585 / 240" src="/images/sub/service/service-museum-img5.png" class="grey-ef" />
                                        </div>
                                        <div class="gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30">
                                            <div class="mb-10">
                                                <h4 class="tit tit--xs d-flex flex-wrap align-center">체계적인 문서화 작업</h4>
                                            </div>
                                            <div>
                                                <ul class="letter-list">
                                                    <li><em>-</em><span>진품보증서, 상태검사서, 작품이력서, 전시도록, 참고문헌, 설치방법서 등 작품의 진품성과 부가가치에 기여하는 중요한 자료들을 꼼꼼히 챙겨서 고객에게 일괄 전달합니다.</span></li>
                                                    <li><em>-</em><span>인보이스, 매매계약서, 송금신청서, 보험가입신청서, 수입면장 등 작품수입과 관련된 중요 문서들을 고객에게 일괄 전달 합니다.</span></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <v-divider class="primary"></v-divider>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </section>
            </div>
        </v-container>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
export default {
    components: {
        ClientPage,
    },
};
</script>

<style lang="scss" scoped>
</style>